import React, { FC, memo, useCallback, useState } from "react";

import { IPositionWrapperProps, PositionWrapper } from "../PositionWrapper";
import { TStyleDirection } from "../Style";
import { ITooltipComponentProps, TooltipComponent } from "./TooltipComponent";

export interface ITooltipProps extends ITooltipComponentProps {}

export const Tooltip: FC<ITooltipProps> = memo(
  ({
    content,
    children,
    placement = "bottom" as IPositionWrapperProps["placement"],
    arrowSize = "sm",
    padding = ["xs", "sm"] as TStyleDirection,
    radius = true,
    size = "sm",
  }) => {
    const [active, setActive] = useState(false);

    const handleMouseEnter = useCallback(() => {
      setActive(true);
    }, []);
    const handleMouseLeave = useCallback(() => {
      setActive(false);
    }, []);

    const Content = (
      <TooltipComponent
        padding={padding}
        content={content}
        arrowSize={arrowSize}
        radius={radius}
        size={size}
        placement={placement}
      />
    );

    const Target = (
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
    );

    return (
      <PositionWrapper hidden={!active} placement={placement} popperComponent={Content} targetComponent={Target} />
    );
  },
);
